export default class PricingModel {}

PricingModel.Marketplace = 'MARKETPLACE';
PricingModel.Standard = 'STANDARD';
